export default __webpack_public_path__ + "static/media/Warlord's War Glaive.705dc21d.jpg";